var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusprimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 19 18",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.1709 9.0002h9.6m-4.8 4.8v-9.6",
    stroke: "#9374ff",
    strokeLinecap: "round",
    strokeWidth: 1.49989
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusprimary);
export default __webpack_public_path__ + "static/media/plus.primary.e52efa24d2f44dc58d9e8c4fdfc8f9e5.svg";
export { ForwardRef as ReactComponent };